<div class="wrapper__form container mt-5 mb-3 border__form">
  <div class="row">
    <div class="d-flex flex-row align-items-start">
      <img
        src="../../../../assets/img/file-alt.svg"
        alt="logo"
        class="img-ico-form" />
      <h2 class="mb-0">{{ asuntosText['asuntos-mercantiles']['titulo'] }}</h2>
    </div>
  </div>
  <app-recuadro-justino></app-recuadro-justino>
  <!--Formulario inicial-->
  <app-form
    [title]="asuntosText['asuntos-mercantiles']['creacion-demanda']"
    [fields]="asunto"
    (changedControl)="onSubmitAsunto($event)"
    [withSubmitButton]="false"
    [idEntidad]="entidadId">
  </app-form>
  <div id="demandantes">
    <app-form
      [title]="asuntosText['asuntos-mercantiles']['tipo-persona-solicitud']"
      *ngIf="mostrarTipoPersonaDemandante"
      [fields]="tipoPersonaDemandante"
      (changedControl)="onSubmitTipoPersonaDemandante($event)"
      [withSubmitButton]="false"
      [withCamposObligatorios]="false"
      [idEntidad]="entidadId">
    </app-form>
    <!--Formularios demandante PN-->
    <app-form
      *ngIf="
        mostrarFomularioNaturalDemandante &&
        idTipoPersonaSeleccionadoDemandante == 1
      "
      [fields]="demandantePN"
      (changeAction)="onSubmitDatosDemandantePN($event)"
      (changedControl)="validarFormularioDemandanteN($event)"
      [sumbitButtonText]="
        isEditarDemandante
          ? asuntosText['asuntos-mercantiles']['actualizar']
          : asuntosText['agregar']
      "
      [withSubmitButton]="true"
      [withCamposObligatorios]="false"
      [alwaysEnableSubmit]="true"
      (submitAction)="guardarDemandante($event, 1, false)"
      [idEntidad]="entidadId">
    </app-form>
    <!--Formularios demandante PJ y Representante legal-->
    <app-form
      *ngIf="
        mostrarFomularioJuridicoDemandante &&
        idTipoPersonaSeleccionadoDemandante == 2
      "
      [fields]="demandantePJ"
      (changeAction)="onSubmitDatosDemandantePJ($event)"
      (changedControl)="validarFormularioDemandanteJ($event)"
      [sumbitButtonText]="
        isEditarDemandante
          ? asuntosText['asuntos-mercantiles']['actualizar']
          : asuntosText['agregar']
      "
      [withSubmitButton]="true"
      [withCamposObligatorios]="false"
      [alwaysEnableSubmit]="true"
      (submitAction)="guardarDemandante($event, 2, false)"
      [idEntidad]="entidadId">
    </app-form>
  </div>

  <div id="apoderados">
    <div
      *ngIf="mostrarApoderado == false && apoderado.length == 0"
      class="col-12 d-flex justify-content-start mt-3">
      <button class="btn-govco fill-add-govco m-1" (click)="addFormApoderado()"
      [attr.aria-label]="asuntosText['asuntos-mercantiles']['agregar-apoderado']">
        {{ asuntosText['asuntos-mercantiles']['agregar-apoderado'] }}
      </button>
    </div>
    <app-form
      *ngIf="mostrarApoderado"
      [fields]="apoderado"
      (changeAction)="onSubmitApoderado($event)"
      (changedControl)="validarFormularioApoderado($event)"
      [sumbitButtonText]="
        isEditarApoderado
          ? asuntosText['asuntos-mercantiles']['actualizar']
          : asuntosText['agregar']
      "
      [withSubmitButton]="true"
      [withCamposObligatorios]="false"
      [alwaysEnableSubmit]="true"
      (submitAction)="guardarApoderado($event, false)"
      [idEntidad]="entidadId">
    </app-form>

  </div>
  <div id="demandandos">
    <app-form
      *ngIf="mostrarTipoPersonaDemandada"
      [fields]="tipoPersonaDemandanda"
      (changedControl)="onSubmitDemandanda($event)"
      [withSubmitButton]="false"
      [withCamposObligatorios]="false"
      [idEntidad]="entidadId">
    </app-form>
    <!--Formularios demandada PN-->
    <app-form
      *ngIf="
        mostrarFomularioNaturalDemandada &&
        idTipoPersonaSeleccionadoDemandada == 1
      "
      [fields]="demandadaPN"
      (changeAction)="onSubmitDatosDemandadaPN($event)"
      (changedControl)="validarFormularioDemandadaN($event)"
      [sumbitButtonText]="
        isEditarDemandado
          ? asuntosText['asuntos-mercantiles']['actualizar']
          : asuntosText['agregar']
      "
      [withSubmitButton]="true"
      [withCamposObligatorios]="false"
      [alwaysEnableSubmit]="true"
      (submitAction)="guardarDemandado($event, 1, false)"
      [idEntidad]="entidadId">
    </app-form>
    <app-form
      *ngIf="
        mostrarFomularioJuridicoDemandada &&
        idTipoPersonaSeleccionadoDemandada == 2
      "
      [fields]="demandadaPJ"
      (changeAction)="onSubmitDatosDemandadaPJ($event)"
      (changedControl)="validarFormularioDemandadaJ($event)"
      [sumbitButtonText]="
        isEditarDemandado
          ? asuntosText['asuntos-mercantiles']['actualizar']
          : asuntosText['agregar']
      "
      [withSubmitButton]="true"
      [withCamposObligatorios]="false"
      [alwaysEnableSubmit]="true"
      (submitAction)="guardarDemandado($event, 2, false)"
      [idEntidad]="entidadId">
    </app-form>
  </div>
  <div id="cancelar" class="col-12 d-flex mt-3 mb-3 justify-content-end">
    <button
      class="btn-govco fill-add-govco m-1"
      (click)="cancelarAgregar()"
      *ngIf="
        mostrarTipoPersonaDemandante ||
        mostrarApoderado ||
        mostrarTipoPersonaDemandada
      "
      [attr.aria-label]="asuntosText['asuntos-mercantiles']['cancelar']">
      {{ asuntosText['asuntos-mercantiles']['cancelar'] }}
    </button>
  </div>
  <div class="mt-3">
    <h2>{{asuntosText['asuntos-mercantiles']['vista-involucrados']}}</h2>
    <div>
      <h3>{{asuntosText['asuntos-mercantiles']['demandantes']}}</h3>
      <div class="col-12 d-flex justify-content-end">
        <button
          class="btn-govco fill-add-govco m-1"
          (click)="addDemandante('demandantes')"
          [attr.aria-label]="asuntosText['asuntos-mercantiles']['agregar-demandante']">
          {{asuntosText['asuntos-mercantiles']['agregar-demandante']}}
        </button>
      </div>
      <app-table
        [estiloEncabezado]="'height: auto !important;'"
        id="tblDemandante"
        [acciones]="actions"
        (eventoAccion)="acciones($event, 'demandante')"
        [datos]="dataTableDemandantes"
        [columnas]="columnsDemandantes"
        [paginacion]="false">
      </app-table>
      <br />
    </div>
    <div>
      <h3>{{asuntosText['asuntos-mercantiles']['apoderado']}}</h3>
      <div class="col-12 d-flex justify-content-end">
        <button
          class="btn-govco fill-add-govco m-1"
          (click)="scrollToSection('apoderados')"
          [attr.aria-label]="asuntosText['asuntos-mercantiles']['agregar-apoderado']">
          {{ asuntosText['asuntos-mercantiles']['agregar-apoderado'] }}
        </button>
      </div>
      <app-table
        [estiloEncabezado]="'height: auto !important;'"
        id="tblApoderado"
        [acciones]="actions"
        (eventoAccion)="acciones($event, 'apoderado')"
        [datos]="dataTableApoderado"
        [columnas]="columnsApoderados"
        [paginacion]="false">
      </app-table>
      <br />
    </div>
    <div>
      <h3>{{asuntosText['asuntos-mercantiles']['demandados']}}</h3>
      <div class="col-12 d-flex justify-content-end">
        <button
          class="btn-govco fill-add-govco m-1"
          (click)="scrollToSection('demandandos')"
          [attr.aria-label]="asuntosText['asuntos-mercantiles']['agregar-demandado']">
          {{ asuntosText['asuntos-mercantiles']['agregar-demandado'] }}
        </button>
      </div>
      <app-table
        [estiloEncabezado]="'height: auto !important;'"
        id="tblDemandado"
        [acciones]="actions"
        (eventoAccion)="acciones($event, 'demandado')"
        [datos]="dataTableDemandados"
        [columnas]="columnsDemandados"
        [paginacion]="false">
      </app-table>
      <br />
    </div>
  </div>
  <div class="mt-3" *ngIf="mostrarArchivos">
    <div class="card">
      <div class="card-header">
        <h5 class="card-title">
          {{ asuntosText['asuntos-mercantiles']['agregar-anexos'] }}
        </h5>
      </div>
      <div class="card-body form-group">
        <app-cargue-archivos-tramite
          *ngIf="mostrarArchivos"
          [archivosPreCargados]="archivosPreCargados"
          [idTipoTramite]="tipoTramite"
          [idTramite]="idTramiteAsuntosMercantiles"
          [btnEnviar]="false"
          [enviar]="enviarDocumentos"
          [nombreCortoTramite]="nombreTramite"
          [enviarEntidad]="enviarEntidad"
          (guardo)="subirArchivo($event)"
          (archivosCargados)="validarArchivosCargados($event)">
        </app-cargue-archivos-tramite>
        <div class="mt-3 text-muted small d-flex align-items-center">
          <i class="bi bi-info-circle me-2"></i>
          {{ 'copia_envio.peso_actual' | translate:{ peso: pesoArchivos } }}
        </div>
      </div>
    </div>
  </div>
  <div class="mt-3 p-3 border bg-light" *ngIf="validarDocumentosObligatorios()">
    <div class="alert alert-info">
      <p>
        <strong>{{ 'confirmacion_envio.titulo' | translate }}</strong>
        {{ 'confirmacion_envio.mensaje' | translate }}
      </p>
      <p class="fst-italic">
        {{ 'confirmacion_envio.nota' | translate }}
      </p>
    </div>
    <div class="form-check">
      <input
        class="form-check-input"
        type="checkbox"
        id="confirmacionEnvio"
        [(ngModel)]="confirmacionEnvio"
      />
      <label class="form-check-label" for="confirmacionEnvio">
        {{ 'confirmacion_envio.checkbox' | translate }}
      </label>
    </div>
  </div>

  <div *ngIf="confirmacionEnvio" class="border p-4 mt-4 bg-white shadow-sm rounded">
    <h5 class="wrapper__form__title mb-0">
      {{ 'copia_envio.desea_enviar_copia' | translate }}
    </h5>

    <p>
      {{ 'copia_envio.descripcion' | translate: resumenCopiaEnvio }}
    </p>


    <div class="d-flex gap-2 mt-3">
      <button
        type="button"
        class="btn btn-outline-secondary"
        (click)="rechazarEnvio()"
        [attr.aria-label]="'copia_envio.rechazar' | translate">
        {{ 'copia_envio.rechazar' | translate }}
      </button>

      <button
        type="button"
        class="btn btn-primary"
        (click)="aceptarEnvio()"
        [attr.aria-label]="'copia_envio.aceptar' | translate">
        {{ 'copia_envio.aceptar' | translate }}
      </button>
    </div>


  </div>

  <div class="col-12 col-md-12 py-3 d-flex justify-content-end">
    <div class="d-flex flex-column flex-md-row gap-2">
      <button
        class="btn-govco fill-before-btn-govco w-auto"
        (click)="onSubmitCompiladoFormularios(false)"
        [attr.aria-label]="asuntosText['botones-envio']['guardar-sin-enviar']">
        {{ asuntosText['botones-envio']['guardar-sin-enviar'] }}
      </button>
      <button
        class="btn-govco fill-send-govco w-auto"
        (click)="onSubmitCompiladoFormularios(true)"
        [attr.aria-label]="asuntosText['botones-envio']['enviar']">
        {{ asuntosText['botones-envio']['enviar'] }}
      </button>
    </div>
  </div>
  <!--Archivos-->

</div>
